import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import API_CONTACT from '../../api/apiContact';
import Alert from '../Alert/Alert';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_CONTACT_INSERT, TICKET_LIST_ALL_CONTACT_INSERT_ASSIGNEE } from '../../constants/menuPermissionConstant';

class CollapseCustomerContact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened: false,
            showAddContact: false,
            name: '',
            phone: '',
            email: '',
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleCollapse = () => {
        if (this.state.showAddContact) {
            return this.setState({
                showAddContact: !this.state.showAddContact
            })
        }
        this.setState({
            isOpened: !this.state.isOpened
        })
    }

    handleShowAddContact = () => {
        this.setState({
            isOpened: !this.state.isOpened,
            showAddContact: !this.state.showAddContact
        })
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleAddContact = () => {
        const data = {
            pic_name: this.state.name,
            customer_id: this.props.data.customer_id,
            phone: this.state.phone,
            pic_email: this.state.email,
            updated_at: this.props.data.updated_at
        }

        API_CONTACT.putDataPicContact(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => this.props.history.push(ROUTER_CONSTANT.CONTACT), 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlert: false
                })
            })
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
        return true
    }

    render() {
        return (
            <div className="text-sm border-b-2 border-gray-500 p-5">
                <div className="flex items-center justify-between cursor-pointer select-none" id="btncontactcollapse" onClick={() => this.handleCollapse()}>
                    <p>{this.state.showAddContact ? "Tambah Kontak" : "Kontak Distributor"}</p>
                    <FontAwesomeIcon icon={this.state.isOpened || this.state.showAddContact ? faChevronUp : faChevronDown} className="text-darkblue" />
                </div>
                <div className={!this.state.isOpened ? "hidden" : null}>
                    <div className="flex justify-between items-center mt-5 mb-3">
                        <p>Email</p>
                        <p>{this.props.data.customer_email === "" ? "-" : this.props.data.customer_email}</p>
                    </div>
                    <div className="flex justify-between items-center mb-3">
                        <p>Phone</p>
                        <p>{this.props.data.customer_phone === "" ? "-" : this.props.data.customer_phone}</p>
                    </div>
                    <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_CONTACT_INSERT, TICKET_LIST_ALL_CONTACT_INSERT_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                        {
                            this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && this.checkCustomerServiceAssignee() &&
                            <button type="button" id="btnaddcontact" className="block bg-lightblue rounded-2xl text-white mx-auto w-full py-1" onClick={() => this.handleShowAddContact()}>Tambah Kontak</button>
                        }
                    </CheckPermissionComponent>
                </div>
                <div className={!this.state.showAddContact ? "hidden" : null}>
                    <div className="mt-5">
                        <label htmlFor="tslcontactname">Nama Kontak</label>
                        <input type="text" id="tslcontactname" className="form-control" placeholder="Tulis Nama Kontak" name="name" autoComplete="off" onChange={this.handleChange} maxLength="55" />
                    </div>
                    <div className="mt-5">
                        <label htmlFor="tslcontactphone">Telepon</label>
                        <div className="form-control">
                            <span className="mr-1">+62 |</span>
                            <input type="number" id="tslcontactphone" className="outline-none custom-input w-4/5" placeholder="Tulis Telepon" name="phone" autoComplete="off" onChange={this.handleChange} minLength="6" maxLength="15" />
                        </div>
                    </div>
                    <div className="mt-5">
                        <label htmlFor="tslcontactemail">Email</label>
                        <input type="email" id="tslcontactemail" className="form-control" placeholder="Tulis Email" name="email" autoComplete="off" onChange={this.handleChange} />
                    </div>
                    <div className="flex justify-between items-center mt-5">
                        <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.handleShowAddContact()}>Batal</button>
                        <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.setState({ showConfirmAlert: true })}>Simpan</button>
                    </div>
                </div>
                <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin menambahkan kontak?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleAddContact()} />
                <Alert show={this.state.showSuccessAlert} icon="success" title="Kontak berhasil ditambahkan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default withRouter(connect(mapStateToProps, null)(CollapseCustomerContact));